import ManageOfflineDocumentsPage from './ManageOfflineDocumentsPage';

export default ManageOfflineDocumentsPage;
